/* Decorative motion-blurred bloom — the site's signature mark.
   Pure inline SVG so petal colors follow the theme via --bloom-* tokens. */

function Petals({ cx, cy, count, rx, ry, fill, opacity = 1, offset = 0 }) {
  return (
    <g opacity={opacity}>
      {Array.from({ length: count }, (_, i) => (
        <ellipse
          key={i}
          cx={cx}
          cy={cy - ry * 0.85}
          rx={rx}
          ry={ry}
          fill={fill}
          transform={`rotate(${offset + (i * 360) / count} ${cx} ${cy})`}
        />
      ))}
    </g>
  );
}

function Bloom({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 600 940"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <filter id="bloom-soft" x="-60%" y="-60%" width="220%" height="220%">
          <feGaussianBlur stdDeviation="19" />
        </filter>
        <filter id="bloom-halo" x="-80%" y="-80%" width="260%" height="260%">
          <feGaussianBlur stdDeviation="46" />
        </filter>
        <filter id="bloom-smear" x="-80%" y="-120%" width="260%" height="340%">
          <feGaussianBlur stdDeviation="12 70" />
        </filter>
      </defs>

      {/* vertical motion smear + stems */}
      <g filter="url(#bloom-smear)" opacity="0.5">
        <path
          d="M292 420 C296 560 306 700 316 900"
          stroke="var(--bloom-a)"
          strokeWidth="30"
          fill="none"
        />
        <path
          d="M160 640 C158 720 162 800 168 920"
          stroke="var(--bloom-b)"
          strokeWidth="18"
          fill="none"
        />
      </g>

      {/* soft halo behind the main bloom */}
      <g filter="url(#bloom-halo)">
        <Petals cx={300} cy={370} count={10} rx={54} ry={200} fill="var(--bloom-b)" opacity={0.55} />
      </g>

      {/* main bloom */}
      <g filter="url(#bloom-soft)">
        <Petals cx={300} cy={370} count={12} rx={46} ry={160} fill="var(--bloom-a)" opacity={0.9} />
        <Petals cx={300} cy={370} count={9} rx={38} ry={105} fill="var(--bloom-b)" offset={20} opacity={0.95} />
        <circle cx="300" cy="370" r="52" fill="var(--bloom-c)" />
        <circle cx="300" cy="362" r="24" fill="#FFDFA8" opacity="0.85" />
      </g>

      {/* companion bloom, lower left */}
      <g filter="url(#bloom-soft)">
        <Petals cx={158} cy={640} count={10} rx={30} ry={95} fill="var(--bloom-a)" opacity={0.85} />
        <Petals cx={158} cy={640} count={7} rx={24} ry={60} fill="var(--bloom-b)" offset={26} />
        <circle cx="158" cy="640" r="30" fill="var(--bloom-c)" />
      </g>
    </svg>
  );
}

export default Bloom;
